<div *ngIf="!books">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="books" class="container-fluid">
  <app-navbar></app-navbar>

  <div class="row m-3 p-4">
    <div class="col-xs-12 col-sm-6 col-md-3 border border-warning center p-4">
      <img
        class="editable img-responsive"
        alt=" Avatar"
        id="avatar2"
        src="http://bootdey.com/img/Content/avatar/avatar6.png"
      />
      <br />
      <hr />
      <div style="margin: 10px 0;">
        <h3>Mohamed Eldiyasty</h3>
      </div>

      <div class="border m-2 text-center p-3">
        <a
          href="https://www.facebook.com/Diyasty"
          type="button"
          class="light-blue-text mx-2"
        >
          <i style="font-size: 33px;" class="fab fa-facebook"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/diyasty/"
          type="button"
          class="light-blue-text mx-2"
        >
          <i style="font-size: 33px;" class="fab fa-linkedin"></i>
        </a>
        <a
          href="https://github.com/Diyasty"
          type="button"
          class="light-blue-text mx-2"
        >
          <i style="font-size: 33px;" class="fab fa-github"></i>
        </a>
      </div>
    </div>

    <div class="col-xs-12 col-sm-6 col-md-9 center p-2">
      <div class="text-center">
        <app-recently-added
          [title]="'Best Book i read ever'"
          [cards]="books"
        ></app-recently-added>
      </div>
      <div class="">
        <div class="container section-top ">
          <h1>what i read now</h1>
          <mdb-card class="cards">
            <a>
              <img
                style="margin: 0 auto;"
                mdbWavesEffect
                height="450"
                width="350"
                alt="Responsive image"
                src="https://s3.amazonaws.com/AKIAJC5RLADLUMVRPFDQ.book-thumb-images/adzic.jpg"
              />
            </a>
            <mdb-card-body class="border border-warning">
              <mdb-card-title>
                <h4 class="text-center pt-2">Flex 3 in Action</h4>
              </mdb-card-title>
            </mdb-card-body>
          </mdb-card>
        </div>
      </div>

      <div class="text-center">
        <app-recently-added
          [title]="'Best Books i read ever'"
          [cards]="books"
        ></app-recently-added>
      </div>
    </div>
  </div>
</div>

<!--end of row -->
